import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';

import queryString from 'querystring';

const classes = theme => ({
  container: {
    flexGrow: 1,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8
  },
  item: {},
  inputContainer: {},
  buttonContainer: {
    textAlign: 'center'
  },
  input: {
    marginTop: 8
  },
  button: {
    margin: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  show: {
    display: 'block'
  },
  hide: {
    display: 'none'
  },
  results: {
    background: '#eee',
    padding: '4px 8px'
  }
});

class FareFinder extends Component {
  constructor(props) {
    super();

    const query = queryString.parse(props.location.search.substr(1));
    const { airlineName = ``, rloc = `` } = query;

    this.state = {
      airlineName: airlineName,
      rloc: rloc || ``,
      results: {},
      finding: false,
      found: false,
      error: false,
      query
    };
  }

  rlocChange(ev) {
    this.setState({
      rloc: ev.target.value
    });
  }

  airlineNameChange(ev) {
    this.setState({
      airlineName: ev.target.value
    });
  }

  findFares() {
    const { rloc, airlineName } = this.state;
    const url = process.env.REACT_APP_WIDGET_API;
    const data = { rloc, airlineName };

    this.setState({ finding: true });

    axios.post(`${url}/fare-finder`, data)
      .then((res) => {

        this.setState({
          results: res.data.response,
          finding: false,
          found: true,
          error: false
        });
      })
      .catch((err) => {
        console.log('error!', err);

        this.setState({
          error: err.response.data.message,
          finding: false,
          found: false,
          results: {}
        });
      });
  }

  render() {
    const { classes } = this.props;
    const { airlineName, rloc, finding, error, found, results } = this.state;

    return (
      <Grid container className={classes.container} spacing={0}>
        <Grid item xs={12}>
          <TextField
            id="airlineName"
            label="Airline Name"
            className={classes.input}
            value={airlineName}
            onChange={this.airlineNameChange.bind(this)}
            margin="normal"
            fullWidth
            disabled={finding}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="rloc"
            label="Record Locator"
            className={classes.input}
            value={rloc}
            onChange={this.rlocChange.bind(this)}
            margin="normal"
            fullWidth
            disabled={finding}
          />
        </Grid>
        <Grid item className={classes.buttonContainer} xs={12}>
          <Button
            variant="contained"
            color="default"
            className={classes.button}
            onClick={this.findFares.bind(this)}
            disabled={finding}
          >
            Store Fare
            <Icon className={classes.rightIcon}>input</Icon>
          </Button>
        </Grid>
        <Grid item className={classes.item} xs={12}>
          <LinearProgress className={(finding) ? classes.show : classes.hide} />
        </Grid>
        <Grid item className={(error) ? classes.show : classes.hide} xs={12}>
          <h3>Error Finding Fare!</h3>
          <p>{error}</p>
        </Grid>
        <Grid item className={(found) ? classes.show : classes.hide} xs={12}>
          <h3>Fare saved to PNR!</h3>
          <pre>{JSON.stringify(results, null, 2)}</pre>
        </Grid>
      </Grid>
    );
  }
}

FareFinder.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object
};

export default withStyles(classes)(FareFinder);



// WEBPACK FOOTER //
// ./src/widgets/FareFinder/index.js